module.exports = __webpack_public_path__ + "static/media/pais.c3b7a57a.png";